module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_add-to-unscopables.js
// module id = 1740
// module chunks = 1